const getImageURL = (image: string | File | undefined) => {
  if (!image) return '';
  return typeof image === 'string' ? image : URL.createObjectURL(image);
};

export default getImageURL;
